/* KajuReise Werkstatt - Station 4: die Herstellung als gefuehrtes Minispiel
   (Guided Narrative Interaction / Operational Transparency).

   10 Schritte: Zutaten -> Pigment mischen (Partikel) -> Umgiessen -> Gips
   einstreuen (Schaufel) -> Ruehren -> In die Form giessen (Querschnitt) ->
   Luftblasen klopfen -> Aushaerten (Zeitraffer-Uhr) -> Ausformen (Schieber
   halten + Stein ziehen, Multitouch) -> fertiger Stein (Pseudo-3D-Rotation).

   Alle Grafiken sind bewusst einfache Canvas-Formen:
   PLATZHALTER - hier kommen spaeter echte PNG/SVG, Videos und Sounds rein
   (Slots dokumentiert in OPTIONEN.md). Kein Schritt kann fehlschlagen.       */
(function () {
  'use strict';

  var IS_BROWSER = typeof window !== 'undefined' && typeof document !== 'undefined';
  if (!IS_BROWSER) { if (typeof module !== 'undefined') module.exports = {}; return; }

  var W = 820, H = 920;
  var PAPIER = '#faf7f4', TINTE = '#241813', BRAUN = '#532c29';
  var ORANGE = '#f39200', GELB = '#f1c953', GRUEN = '#6cac53', ROT = '#a93015', TUERKIS = '#0096ae';
  var PIGMENT = '#c05a00';   // dry pigment, darker than the mixed liquid

  var canvas, ctx, taskEl, resetBtn;
  var visible = false, audioCtx = null;

  /* ================= state machine ================= */

  var STEPS = ['zutaten', 'mischen', 'giessen1', 'einstreuen', 'ruehren',
               'giessen2', 'klopfen', 'warten', 'ausformen', 'fertig'];
  var TASKS = {
    zutaten: 'Hartgips braucht drei Dinge. Zieh <b>Wasser</b> und <b>Pigment</b> in den Mischbecher.',
    mischen: 'Wische hin und her, bis sich das Pigment ganz l&ouml;st.',
    giessen1: 'Tipp auf den Becher &ndash; gie&szlig; das farbige Wasser in den Topf.',
    einstreuen: 'F&uuml;hr die Schaufel hin und her &ndash; der Gips rieselt ein.',
    ruehren: 'R&uuml;hr in Kreisen, bis die Masse glatt ist.',
    giessen2: 'Tipp auf den Topf &ndash; gie&szlig; die Masse in die Silikonform.',
    klopfen: 'Tipp auf die Form &ndash; klopf die Luftblasen heraus.',
    warten: 'Kurz warten &ndash; der Gips h&auml;rtet aus.',
    ausformen: 'Halte den <b>Schieber</b> oben &ndash; und zieh den Stein aus der Form.',
    fertig: 'Fertig. Dein Stein &ndash; ein Unikat aus Naturhartgips. Dreh ihn ruhig einmal.'
  };

  var s = null;

  function freshState() {
    return {
      step: 'zutaten',
      // zutaten
      water: false, pigment: false, dragItem: null,
      // mischen
      clumps: [], mixDist: 0, mixDone: 0, lastWipe: null,
      // giessen (shared pour animation)
      pour: 0, pouring: false,
      // einstreuen
      shovelX: W / 2, sprinkleDist: 0, sprinkleTurns: 0, lastDx: 0, sprinkleOn: false, lastShovelX: null,
      // ruehren
      stirAngle: 0, stirTurns: 0, lastStir: null,
      // giessen2 / form
      fill: 0,
      // klopfen
      bubbles: [], wobble: 0,
      // warten
      waitT: 0,
      // ausformen
      slider: 0, sliderLatch: 0, sliderPtr: null, stonePtr: null,
      stoneOut: 0, stoneDrag: null, stoneFree: false, stonePos: null,
      // fertig
      rot: 0, rotDrag: null, earned: false,
      particles: []
    };
  }

  function enter(step) {
    s.step = step;
    if (taskEl) taskEl.innerHTML = TASKS[step];
    if (step === 'mischen') seedClumps();
    if (step === 'klopfen') seedBubbles();
    if (step === 'warten') s.waitT = 0;
  }

  /* ================= layout anchors ================= */

  var BECHER = { x: 300, y: 470, w: 200, h: 220 };            // mixing cup
  var KRUG = { x: 620, y: 330, w: 130, h: 150 };              // water jug
  var DISH = { x: 620, y: 560, w: 130, h: 70 };               // pigment dish
  var TOPF = { x: 410, y: 560, rx: 190, ry: 46, h: 190 };     // big pot (center bottom)
  var FORM = { cx: 410, cy: 470, Ri: 120, Ra: 235, a0: -30, a1: -150, wall: 34 }; // mold cross-section
  var SLIDER = { x: 410, y0: 790, w: 150, h: 56, travel: 96 };

  /* ================= particles ================= */

  function spawn(x, y, vx, vy, color, r, life) {
    s.particles.push({ x: x, y: y, vx: vx, vy: vy, color: color, r: r, life: life, max: life });
  }
  function stepParticles() {
    for (var i = s.particles.length - 1; i >= 0; i--) {
      var p = s.particles[i];
      p.x += p.vx; p.y += p.vy; p.vy += 0.25; p.life--;
      if (p.life <= 0) s.particles.splice(i, 1);
    }
  }
  function drawParticles() {
    for (var i = 0; i < s.particles.length; i++) {
      var p = s.particles[i];
      ctx.globalAlpha = Math.max(0, p.life / p.max);
      ctx.fillStyle = p.color;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 7); ctx.fill();
    }
    ctx.globalAlpha = 1;
  }

  /* ================= step: zutaten ================= */

  function drawKrug(x, y, alpha) {
    ctx.globalAlpha = alpha != null ? alpha : 1;
    // PLATZHALTER - Wasserkrug spaeter als PNG/Foto
    blockShadow(function () {
      ctx.fillStyle = TUERKIS;
      rr(x - 45, y - 60, 90, 120, 10); ctx.fill();
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; rr(x - 45, y - 60, 90, 120, 10); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x + 45, y - 40); ctx.quadraticCurveTo(x + 85, y - 20, x + 45, y + 8);
      ctx.lineWidth = 10; ctx.strokeStyle = TUERKIS; ctx.stroke();
      ctx.lineWidth = 2; ctx.strokeStyle = BRAUN;
    });
    label('Wasser', x, y + 84);
    ctx.globalAlpha = 1;
  }
  function drawDish(x, y, alpha) {
    ctx.globalAlpha = alpha != null ? alpha : 1;
    // PLATZHALTER - Pigment-Schale spaeter als PNG/Foto
    blockShadow(function () {
      ctx.fillStyle = PAPIER;
      ctx.beginPath(); ctx.ellipse(x, y, 62, 26, 0, 0, 7); ctx.fill();
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; ctx.stroke();
    });
    ctx.fillStyle = PIGMENT;
    ctx.beginPath(); ctx.ellipse(x, y - 4, 44, 15, 0, 0, 7); ctx.fill();
    label('Pigment', x, y + 52);
    ctx.globalAlpha = 1;
  }
  function drawBecher(fillLevel, fillColor, tilt) {
    var b = BECHER;
    ctx.save();
    ctx.translate(b.x + b.w / 2, b.y + b.h);
    ctx.rotate(tilt || 0);
    ctx.translate(-(b.x + b.w / 2), -(b.y + b.h));
    // PLATZHALTER - Mischbecher spaeter als PNG/Foto
    blockShadow(function () {
      ctx.fillStyle = '#e7ded2';
      trapez(b.x, b.y, b.w, b.h, 24); ctx.fill();
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; trapez(b.x, b.y, b.w, b.h, 24); ctx.stroke();
    });
    if (fillLevel > 0) {
      ctx.save();
      trapez(b.x, b.y, b.w, b.h, 24); ctx.clip();
      ctx.fillStyle = fillColor;
      ctx.fillRect(b.x, b.y + b.h * (1 - fillLevel), b.w, b.h * fillLevel);
      ctx.restore();
    }
    ctx.restore();
  }

  function zutatenDraw() {
    drawBecher(s.water ? 0.55 : 0, s.pigment ? 'rgba(192,90,0,.55)' : 'rgba(0,150,174,.5)', 0);
    if (s.pigment && s.water) return;
    if (!s.water && !(s.dragItem === 'water')) drawKrug(KRUG.x, KRUG.y);
    if (!s.pigment && !(s.dragItem === 'pigment')) drawDish(DISH.x, DISH.y);
    if (s.dragItem === 'water') drawKrug(s.dragX, s.dragY, 0.85);
    if (s.dragItem === 'pigment') drawDish(s.dragX, s.dragY, 0.85);
  }

  function inRect(p, x, y, w, h) { return p[0] >= x && p[0] <= x + w && p[1] >= y && p[1] <= y + h; }
  function overBecher(p) { return inRect(p, BECHER.x - 40, BECHER.y - 40, BECHER.w + 80, BECHER.h + 80); }

  function zutatenDown(p) {
    if (!s.water && inRect(p, KRUG.x - 60, KRUG.y - 70, 150, 160)) { s.dragItem = 'water'; s.dragX = p[0]; s.dragY = p[1]; return; }
    if (!s.pigment && inRect(p, DISH.x - 70, DISH.y - 40, 140, 100)) { s.dragItem = 'pigment'; s.dragX = p[0]; s.dragY = p[1]; return; }
  }
  function zutatenMove(p) { if (s.dragItem) { s.dragX = p[0]; s.dragY = p[1]; } }
  function zutatenUp(p, wasTap) {
    if (!s.dragItem) return;
    var it = s.dragItem; s.dragItem = null;
    // tap-to-place OR drop over the cup - both count (fehlerverzeihend)
    if (wasTap || overBecher(p)) {
      if (it === 'water') { s.water = true; splashInBecher(TUERKIS); }
      else { s.pigment = true; splashInBecher(PIGMENT); }
      buzz(12); blip(300, 0.08);
      if (s.water && s.pigment) setTimeout(function () { enter('mischen'); }, 500);
    }
  }
  function splashInBecher(color) {
    for (var i = 0; i < 14; i++) {
      spawn(BECHER.x + BECHER.w / 2 + (Math.random() - 0.5) * 60, BECHER.y + 30,
        (Math.random() - 0.5) * 3, -Math.random() * 4, color, 3 + Math.random() * 3, 30);
    }
  }

  /* ================= step: mischen ================= */

  function seedClumps() {
    s.clumps = [];
    for (var i = 0; i < 6; i++) {
      s.clumps.push({
        x: BECHER.x + 40 + Math.random() * (BECHER.w - 80),
        y: BECHER.y + 60 + Math.random() * (BECHER.h - 100),
        r: 14 + Math.random() * 8, hp: 1
      });
    }
    s.mixDist = 0; s.mixDone = 0; s.lastWipe = null;
  }

  var MIX_NEED = 2400;

  function mischenDraw() {
    var t = Math.min(1, s.mixDist / MIX_NEED);
    s.mixDone = t;
    // liquid: pale water -> homogeneous orange
    var col = lerpColor([180, 215, 220], [243, 146, 0], t);
    drawBecher(0.6, 'rgb(' + col.join(',') + ')', 0);
    // agglomerated pigment clumps break up as you wipe
    for (var i = 0; i < s.clumps.length; i++) {
      var c = s.clumps[i];
      if (c.hp <= 0) continue;
      ctx.fillStyle = PIGMENT;
      for (var k = 0; k < 6; k++) {
        var a = k * 1.05 + i, rr2 = c.r * c.hp * (0.4 + 0.2 * ((k * 7 + i) % 3));
        ctx.beginPath();
        ctx.arc(c.x + Math.cos(a) * rr2 * 0.7, c.y + Math.sin(a) * rr2 * 0.5, Math.max(1.5, rr2 * 0.35), 0, 7);
        ctx.fill();
      }
    }
    hint('wischen', BECHER.x + BECHER.w / 2, BECHER.y - 26);
  }
  function mischenMove(p, down) {
    if (!down) return;
    if (s.lastWipe) {
      var d = Math.hypot(p[0] - s.lastWipe[0], p[1] - s.lastWipe[1]);
      if (overBecher(p)) {
        s.mixDist += d;
        // wiping near a clump shatters it into drifting particles
        for (var i = 0; i < s.clumps.length; i++) {
          var c = s.clumps[i];
          if (c.hp > 0 && Math.hypot(p[0] - c.x, p[1] - c.y) < 70) {
            c.hp -= 0.045;
            spawn(c.x, c.y, (Math.random() - 0.5) * 2.4, -Math.random() * 1.6, PIGMENT, 2.2, 26);
            if (c.hp <= 0) { buzz(8); blip(340, 0.05); }
          }
        }
        if (s.mixDist >= MIX_NEED && !s.clumps.some(function (c) { return c.hp > 0.15; })) {
          enter('giessen1'); buzz(14);
        }
      }
    }
    s.lastWipe = p;
  }

  /* ================= steps: giessen1 / giessen2 (pour animation) ================= */

  function drawTopf(fillLevel, fillColor, thick) {
    var t = TOPF;
    // PLATZHALTER - Anruehrtopf spaeter als PNG/Foto
    blockShadow(function () {
      ctx.fillStyle = '#8d8d94';
      ctx.beginPath();
      ctx.moveTo(t.x - t.rx, t.y);
      ctx.lineTo(t.x - t.rx + 14, t.y + t.h);
      ctx.lineTo(t.x + t.rx - 14, t.y + t.h);
      ctx.lineTo(t.x + t.rx, t.y);
      ctx.closePath(); ctx.fill();
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; ctx.stroke();
    });
    ctx.fillStyle = '#77777e';
    ctx.beginPath(); ctx.ellipse(t.x, t.y, t.rx, t.ry, 0, 0, 7); ctx.fill();
    ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; ctx.stroke();
    if (fillLevel > 0) {
      ctx.fillStyle = fillColor;
      ctx.beginPath();
      ctx.ellipse(t.x, t.y + 6, (t.rx - 14) * (0.6 + 0.4 * fillLevel), (t.ry - 8) * (0.6 + 0.4 * fillLevel), 0, 0, 7);
      ctx.fill();
      if (thick) { ctx.strokeStyle = 'rgba(83,44,41,.25)'; ctx.lineWidth = 3; ctx.stroke(); }
    }
  }

  function giessen1Draw() {
    if (s.pouring) {
      s.pour = Math.min(1, s.pour + 0.016);
      // stream of coloured water
      for (var i = 0; i < 3; i++) {
        spawn(TOPF.x - 60 + Math.random() * 24, 340 + Math.random() * 20, 0, 5 + Math.random() * 2, ORANGE, 3.4, 40);
      }
      if (s.pour >= 1) { s.pouring = false; setTimeout(function () { enter('einstreuen'); }, 300); }
    }
    drawTopf(s.pour * 0.5, 'rgba(243,146,0,.85)');
    // cup, tilted over the pot while pouring
    ctx.save();
    ctx.translate(s.pouring ? TOPF.x - 170 : 0, s.pouring ? -260 : 0);
    drawBecher(0.6 * (1 - s.pour), ORANGE, s.pouring ? 0.9 : 0);
    ctx.restore();
    if (!s.pouring) hint('tippen', BECHER.x + BECHER.w / 2, BECHER.y - 26);
  }
  function giessen1Down() { if (!s.pouring) { s.pouring = true; s.pour = 0; buzz(10); blip(260, 0.1); } }

  /* ================= step: einstreuen ================= */

  var SPRINKLE_NEED = 1700;

  function drawSchaufel(x, y) {
    // PLATZHALTER - Schaufel spaeter als PNG/Foto
    blockShadow(function () {
      ctx.fillStyle = '#b3703a';
      ctx.fillRect(x - 7, y - 90, 14, 68);
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; ctx.strokeRect(x - 7, y - 90, 14, 68);
      ctx.fillStyle = PAPIER;
      ctx.beginPath();
      ctx.moveTo(x - 42, y - 24); ctx.lineTo(x + 42, y - 24);
      ctx.lineTo(x + 30, y + 22); ctx.lineTo(x - 30, y + 22);
      ctx.closePath(); ctx.fill(); ctx.stroke();
    });
    // heap of plaster on the shovel
    ctx.fillStyle = '#fff';
    ctx.beginPath(); ctx.ellipse(x, y - 22, 34, 12, 0, Math.PI, 0); ctx.fill();
  }

  function einstreuenDraw() {
    drawTopf(0.5, 'rgba(243,146,0,.85)');
    var t = Math.min(1, s.sprinkleDist / SPRINKLE_NEED);
    // plaster mound grows in the pot
    if (t > 0.05) {
      ctx.fillStyle = 'rgba(250,247,244,.92)';
      ctx.beginPath();
      ctx.ellipse(TOPF.x, TOPF.y + 4, (TOPF.rx - 30) * t, (TOPF.ry - 6) * t, 0, 0, 7);
      ctx.fill();
    }
    drawSchaufel(s.shovelX, 300);
    if (s.sprinkleOn) {
      for (var i = 0; i < 3; i++) {
        spawn(s.shovelX + (Math.random() - 0.5) * 56, 300, (Math.random() - 0.5) * 0.6, 3.4 + Math.random() * 2, '#fff', 2, 52);
      }
    }
    hint('hin & her wischen', TOPF.x, 210);
  }
  function einstreuenMove(p, down) {
    s.shovelX = Math.max(TOPF.x - TOPF.rx + 40, Math.min(TOPF.x + TOPF.rx - 40, p[0]));
    if (!down) { s.sprinkleOn = false; s.lastShovelX = null; return; }
    if (s.lastShovelX != null) {
      var dx = p[0] - s.lastShovelX;
      s.sprinkleOn = Math.abs(dx) > 1.5;
      if (s.sprinkleOn) s.sprinkleDist += Math.abs(dx);
      if (dx !== 0 && s.lastDx !== 0 && Math.sign(dx) !== Math.sign(s.lastDx)) s.sprinkleTurns++;
      if (dx !== 0) s.lastDx = dx;
      if (s.sprinkleDist >= SPRINKLE_NEED && s.sprinkleTurns >= 4) { enter('ruehren'); buzz(14); }
    }
    s.lastShovelX = p[0];
  }

  /* ================= step: ruehren ================= */

  function ruehrenDraw() {
    var t = Math.min(1, s.stirTurns / 3);
    var col = lerpColor([243, 146, 0], [247, 195, 120], t);   // creamy as it thickens
    drawTopf(0.62, 'rgb(' + col.join(',') + ')', true);
    if (s.lastStir) {
      // the stirring stick follows the finger
      blockShadow(function () {
        ctx.strokeStyle = '#b3703a'; ctx.lineWidth = 12;
        ctx.beginPath(); ctx.moveTo(s.lastStir[0], s.lastStir[1] - 130); ctx.lineTo(s.lastStir[0], s.lastStir[1]); ctx.stroke();
      });
    }
    // progress ring
    ctx.strokeStyle = 'rgba(250,247,244,.35)'; ctx.lineWidth = 5;
    ctx.beginPath(); ctx.arc(TOPF.x, TOPF.y - 130, 30, 0, 7); ctx.stroke();
    ctx.strokeStyle = GELB;
    ctx.beginPath(); ctx.arc(TOPF.x, TOPF.y - 130, 30, -Math.PI / 2, -Math.PI / 2 + t * Math.PI * 2); ctx.stroke();
    hint('kreisen', TOPF.x, 210);
  }
  function ruehrenMove(p, down) {
    if (!down) { s.lastStir = null; return; }
    var a = Math.atan2(p[1] - TOPF.y, p[0] - TOPF.x);
    if (s.lastStir) {
      var prev = Math.atan2(s.lastStir[1] - TOPF.y, s.lastStir[0] - TOPF.x);
      var d = a - prev;
      while (d > Math.PI) d -= 2 * Math.PI;
      while (d < -Math.PI) d += 2 * Math.PI;
      s.stirAngle += Math.abs(d);
      s.stirTurns = s.stirAngle / (Math.PI * 2);
      if (s.stirTurns >= 3) { enter('giessen2'); buzz(14); }
    }
    s.lastStir = p;
  }

  /* ================= steps: giessen2 + form (cross-section) ================= */

  function moldPath(inflate) {
    // cavity = annular 60deg segment (cross-section of one gelb stone), apex up
    var f = FORM, inf = inflate || 0;
    var a0 = (f.a0 * Math.PI) / 180, a1 = (f.a1 * Math.PI) / 180;
    ctx.beginPath();
    ctx.arc(f.cx, f.cy, f.Ra + inf, a0, a1, true);
    ctx.arc(f.cx, f.cy, f.Ri - inf, a1, a0, false);
    ctx.closePath();
  }

  function drawForm(fillLevel, cured, stoneOffset) {
    var f = FORM;
    ctx.save();
    ctx.translate((Math.random() - 0.5) * s.wobble, 0);
    if (s.wobble > 0) s.wobble *= 0.86;
    // silicone block around the cavity
    // PLATZHALTER - Silikonform spaeter als Foto/Video-Querschnitt
    blockShadow(function () {
      ctx.fillStyle = '#9fb4c8';
      rr(f.cx - f.Ra - f.wall, f.cy - f.Ra - f.wall + 95, (f.Ra + f.wall) * 2, f.Ra + f.wall + 40, 18);
      ctx.fill();
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2;
      rr(f.cx - f.Ra - f.wall, f.cy - f.Ra - f.wall + 95, (f.Ra + f.wall) * 2, f.Ra + f.wall + 40, 18);
      ctx.stroke();
    });
    // cavity
    ctx.save();
    ctx.translate(0, 95);
    ctx.fillStyle = '#7e93a8';
    moldPath(3); ctx.fill();
    if (fillLevel > 0) {
      ctx.save();
      moldPath(0); ctx.clip();
      var top = f.cy - f.Ra, bot = f.cy - f.Ri * 0.5;
      ctx.fillStyle = cured ? GELB : 'rgb(247,195,120)';
      var yFill = bot - (bot - top) * fillLevel - (stoneOffset || 0);
      ctx.fillRect(f.cx - f.Ra, yFill - 600 + 600, f.Ra * 2, 600);
      // NOTE: stoneOffset lifts the cured stone out of the mold
      ctx.restore();
      if (cured && stoneOffset) {
        // draw the freed part of the stone above the mold
        ctx.save();
        ctx.translate(0, -(stoneOffset || 0));
        ctx.fillStyle = GELB;
        moldPath(0); ctx.fill();
        ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; ctx.stroke();
        ctx.restore();
      }
    }
    ctx.restore();
    ctx.restore();
  }

  function giessen2Draw() {
    if (s.pouring) {
      s.fill = Math.min(1, s.fill + 0.012);
      for (var i = 0; i < 2; i++) {
        spawn(FORM.cx + (Math.random() - 0.5) * 30, 180 + Math.random() * 16, 0, 4.5, 'rgb(247,195,120)', 4, 46);
      }
      if (s.fill >= 1) { s.pouring = false; setTimeout(function () { enter('klopfen'); }, 350); }
    }
    drawForm(s.fill, false, 0);
    if (!s.pouring) hint('tippen', FORM.cx, 200);
  }
  function giessen2Down() { if (!s.pouring) { s.pouring = true; buzz(10); blip(240, 0.1); } }

  /* ================= step: klopfen ================= */

  function seedBubbles() {
    s.bubbles = [];
    for (var i = 0; i < 9; i++) {
      s.bubbles.push({
        x: FORM.cx + (Math.random() - 0.5) * (FORM.Ra * 1.1),
        y: FORM.cy + 95 - FORM.Ri - Math.random() * 60,
        r: 4 + Math.random() * 5, rising: false, gone: false
      });
    }
  }
  function klopfenDraw() {
    drawForm(1, false, 0);
    var left = 0;
    for (var i = 0; i < s.bubbles.length; i++) {
      var b = s.bubbles[i];
      if (b.gone) continue;
      left++;
      if (b.rising) {
        b.y -= 1.6; b.x += Math.sin(b.y * 0.08) * 0.6;
        if (b.y < FORM.cy + 95 - FORM.Ra + 26) {
          b.gone = true;
          for (var k = 0; k < 5; k++) spawn(b.x, b.y, (Math.random() - 0.5) * 2, -1, PAPIER, 1.6, 18);
          blip(600, 0.04);
        }
      }
      ctx.strokeStyle = 'rgba(250,247,244,.85)'; ctx.lineWidth = 1.5;
      ctx.beginPath(); ctx.arc(b.x, b.y, b.r, 0, 7); ctx.stroke();
    }
    if (left === 0) { enter('warten'); buzz(16); }
    else hint('tippen', FORM.cx, 200);
  }
  function klopfenDown() {
    s.wobble = 7; buzz(15); blip(180, 0.06);
    var released = 0;
    for (var i = 0; i < s.bubbles.length && released < 3; i++) {
      if (!s.bubbles[i].gone && !s.bubbles[i].rising) { s.bubbles[i].rising = true; released++; }
    }
  }

  /* ================= step: warten (time lapse clock) ================= */

  function wartenDraw() {
    drawForm(1, s.waitT > 0.6, 0);
    s.waitT = Math.min(1, s.waitT + 1 / 160);
    // PLATZHALTER - spaeter echtes Zeitraffer-Video aus der Werkstatt
    var cx = FORM.cx, cy = 200, R = 56;
    blockShadow(function () {
      ctx.fillStyle = PAPIER;
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 7); ctx.fill();
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; ctx.stroke();
    });
    var a = s.waitT * Math.PI * 8 - Math.PI / 2;
    ctx.strokeStyle = TINTE; ctx.lineWidth = 4;
    ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + Math.cos(a) * (R - 16), cy + Math.sin(a) * (R - 16)); ctx.stroke();
    ctx.lineWidth = 3;
    ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + Math.cos(a / 8) * (R - 28), cy + Math.sin(a / 8) * (R - 28)); ctx.stroke();
    if (s.waitT >= 1) enter('ausformen');
  }

  /* ================= step: ausformen (slider hold + pull, multitouch) ================= */

  function sliderRect() {
    var sl = SLIDER;
    var y = sl.y0 - s.slider * sl.travel;
    return { x: sl.x - sl.w / 2, y: y, w: sl.w, h: sl.h };
  }

  function ausformenDraw() {
    var pushed = s.slider * 58;                       // how far the stone is pushed out
    var lift = s.stoneDrag ? s.stoneOut : 0;
    if (!s.stoneFree) drawForm(1, true, pushed + lift);
    else drawForm(0, false, 0);
    // the freed stone follows the finger
    if (s.stoneFree && s.stonePos) {
      ctx.save();
      ctx.translate(s.stonePos[0] - FORM.cx, s.stonePos[1] - (FORM.cy + 95 - (FORM.Ri + FORM.Ra) / 2));
      ctx.translate(0, 95 - 95);
      drawStoneSegment(FORM.cx, FORM.cy + 95, 1);
      ctx.restore();
    }
    // slider under the mold
    var r = sliderRect();
    blockShadow(function () {
      ctx.fillStyle = s.slider > 0.75 ? ROT : '#7e5a3c';
      rr(r.x, r.y, r.w, r.h, 10); ctx.fill();
      ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; rr(r.x, r.y, r.w, r.h, 10); ctx.stroke();
    });
    ctx.fillStyle = PAPIER; ctx.textAlign = 'center';
    ctx.font = '700 17px "Ciutadella", system-ui, sans-serif';
    ctx.fillText('Schieber', SLIDER.x, r.y + 35);
    // guide rail
    ctx.strokeStyle = 'rgba(250,247,244,.3)'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.moveTo(SLIDER.x, SLIDER.y0 + SLIDER.h + 8); ctx.lineTo(SLIDER.x, SLIDER.y0 - SLIDER.travel); ctx.stroke();

    // spring back unless held or latched
    if (!s.sliderPtr && Date.now() > s.sliderLatch) s.slider = Math.max(0, s.slider - 0.05);
    // desktop fallback: fully up -> latches briefly so one pointer can grab the stone
    if (s.slider >= 0.98 && s.sliderPtr == null && s.sliderLatch < Date.now()) { /* latch set on release */ }
    if (s.slider > 0.75) hint('jetzt den Stein ziehen', FORM.cx, 170);
    else hint('Schieber hochschieben & halten', FORM.cx, 170);
  }

  function drawStoneSegment(cx, cy, alpha) {
    ctx.globalAlpha = alpha;
    var keep = { cx: FORM.cx, cy: FORM.cy };
    FORM.cx = cx; FORM.cy = cy - 95;
    blockShadow(function () { ctx.fillStyle = GELB; moldPath(0); ctx.save(); ctx.translate(0, 95); ctx.fill(); ctx.restore(); });
    ctx.save(); ctx.translate(0, 95);
    ctx.fillStyle = GELB; moldPath(0); ctx.fill();
    ctx.strokeStyle = BRAUN; ctx.lineWidth = 2; ctx.stroke();
    ctx.restore();
    FORM.cx = keep.cx; FORM.cy = keep.cy;
    ctx.globalAlpha = 1;
  }

  function stoneHit(p) {
    var top = FORM.cy + 95 - FORM.Ra - 40, bot = FORM.cy + 95 - FORM.Ri + 30;
    return p[0] > FORM.cx - FORM.Ra && p[0] < FORM.cx + FORM.Ra && p[1] > top - 60 && p[1] < bot;
  }

  function ausformenDown(p, e) {
    var r = sliderRect();
    if (inRect(p, r.x - 24, r.y - 24, r.w + 48, r.h + 48)) {
      s.sliderPtr = e.pointerId; s.sliderY = p[1];
      return;
    }
    if (s.slider > 0.75 && stoneHit(p) && s.stonePtr == null) {
      s.stonePtr = e.pointerId; s.stoneDrag = p; s.stoneOut = 0;
    }
  }
  function ausformenMove(p, e) {
    if (e.pointerId === s.sliderPtr) {
      var dy = s.sliderY - p[1];
      s.slider = Math.max(0, Math.min(1, s.slider + dy / SLIDER.travel));
      s.sliderY = p[1];
    } else if (e.pointerId === s.stonePtr && s.stoneDrag) {
      var pull = s.stoneDrag[1] - p[1];
      s.stoneOut = Math.max(0, pull);
      if (s.stoneOut > 130 && !s.stoneFree) {
        s.stoneFree = true; s.stonePos = p;
        squelch(); buzz(30);
      }
      if (s.stoneFree) s.stonePos = p;
    }
  }
  function ausformenUp(e) {
    if (e.pointerId === s.sliderPtr) {
      s.sliderPtr = null;
      if (s.slider >= 0.95) s.sliderLatch = Date.now() + 2000;   // single-pointer fallback
    }
    if (e.pointerId === s.stonePtr) {
      s.stonePtr = null; s.stoneDrag = null;
      if (s.stoneFree) setTimeout(function () { enter('fertig'); }, 250);
      else s.stoneOut = 0;
    }
  }

  /* ================= step: fertig (pseudo 3d rotation) ================= */

  function fertigDraw() {
    if (!s.earned) {
      s.earned = true;
      if (window.KajuReise) window.KajuReise.earn('werkstatt', '+1 Gratisstein · Dein Werkstatt-Stein ist gesichert.');
    }
    /* PLATZHALTER - hier spaeter Stop-Motion-Bildsequenz des echten Steins
       (bildschirmfuellende 3D-Rotation ueber Einzelbilder, Drag scrubbt).     */
    var cx = W / 2, cy = 470;
    var sq = 0.55 + 0.45 * Math.abs(Math.cos(s.rot));    // fake turn: x squash
    var shade = 0.75 + 0.25 * Math.abs(Math.cos(s.rot));
    ctx.save();
    ctx.translate(cx, cy);
    ctx.scale(sq, 1);
    ctx.translate(-cx, -cy);
    var keep = { cx: FORM.cx, cy: FORM.cy, Ri: FORM.Ri, Ra: FORM.Ra };
    FORM.cx = cx; FORM.cy = cy + 60 - 95; FORM.Ri = 150; FORM.Ra = 300;
    ctx.save(); ctx.translate(6, 8); ctx.globalAlpha = 0.3; ctx.fillStyle = '#000';
    ctx.save(); ctx.translate(0, 95); moldPath(0); ctx.fill(); ctx.restore(); ctx.restore();
    ctx.globalAlpha = 1;
    var col = Math.round(241 * shade) + ',' + Math.round(201 * shade) + ',' + Math.round(83 * shade);
    ctx.fillStyle = 'rgb(' + col + ')';
    ctx.save(); ctx.translate(0, 95); moldPath(0); ctx.fill();
    ctx.strokeStyle = BRAUN; ctx.lineWidth = 2.5; ctx.stroke(); ctx.restore();
    FORM.cx = keep.cx; FORM.cy = keep.cy; FORM.Ri = keep.Ri; FORM.Ra = keep.Ra;
    ctx.restore();
    if (!s.rotDrag) s.rot += 0.012;                     // gentle idle spin
    hint('ziehen zum Drehen', cx, 760);
  }
  function fertigMove(p, down) {
    if (down && s.rotDrag) s.rot += (p[0] - s.rotDrag[0]) * 0.012;
    s.rotDrag = down ? p : null;
  }

  /* ================= shared drawing helpers ================= */

  function rr(x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }
  function trapez(x, y, w, h, inset) {
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x + w, y);
    ctx.lineTo(x + w - inset, y + h);
    ctx.lineTo(x + inset, y + h);
    ctx.closePath();
  }
  function blockShadow(paint) {
    ctx.save(); ctx.translate(4, 4); ctx.globalAlpha = 0.28;
    var f = ctx.fillStyle, st = ctx.strokeStyle;
    paint();
    ctx.restore();
    ctx.globalAlpha = 1;
    paint();
  }
  function label(txt, x, y) {
    ctx.fillStyle = 'rgba(250,247,244,.8)'; ctx.textAlign = 'center';
    ctx.font = '600 15px "Ciutadella", system-ui, sans-serif';
    ctx.fillText(txt, x, y);
  }
  function hint(txt, x, y) {
    ctx.fillStyle = 'rgba(250,247,244,.55)'; ctx.textAlign = 'center';
    ctx.font = '600 15px "Ciutadella", system-ui, sans-serif';
    ctx.fillText(txt, x, y);
  }
  function lerpColor(a, b, t) {
    return [Math.round(a[0] + (b[0] - a[0]) * t), Math.round(a[1] + (b[1] - a[1]) * t), Math.round(a[2] + (b[2] - a[2]) * t)];
  }

  /* ================= sound + haptics (placeholders) ================= */

  function buzz(ms) { try { if (navigator.vibrate) navigator.vibrate(ms); } catch (e) { /* ok */ } }
  function audio() {
    if (!audioCtx) { try { audioCtx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { /* ok */ } }
    return audioCtx;
  }
  /* PLATZHALTER - echte Sounds folgen (Wasser, Rieseln, Klopfen, Silikon-Quatsch) */
  function blip(freq, vol) {
    var a = audio(); if (!a) return;
    try {
      var t = a.currentTime, osc = a.createOscillator(), g = a.createGain();
      osc.frequency.setValueAtTime(freq, t);
      osc.frequency.exponentialRampToValueAtTime(freq * 0.4, t + 0.08);
      g.gain.setValueAtTime(vol, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + 0.1);
      osc.connect(g); g.connect(a.destination); osc.start(t); osc.stop(t + 0.12);
    } catch (e) { /* ok */ }
  }
  function squelch() {
    var a = audio(); if (!a) return;
    try {
      var t = a.currentTime, len = 0.18, buf = a.createBuffer(1, a.sampleRate * len, a.sampleRate);
      var d = buf.getChannelData(0);
      for (var i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
      var src = a.createBufferSource(); src.buffer = buf;
      var f = a.createBiquadFilter(); f.type = 'lowpass';
      f.frequency.setValueAtTime(1400, t); f.frequency.exponentialRampToValueAtTime(200, t + len);
      var g = a.createGain(); g.gain.setValueAtTime(0.16, t);
      src.connect(f); f.connect(g); g.connect(a.destination); src.start(t);
    } catch (e) { /* ok */ }
  }

  /* ================= input routing ================= */

  var downPtrs = {};

  function canvasXY(e) {
    var r = canvas.getBoundingClientRect();
    return [(e.clientX - r.left) * (W / r.width), (e.clientY - r.top) * (H / r.height)];
  }

  function onDown(e) {
    var p = canvasXY(e);
    downPtrs[e.pointerId] = p;
    try { canvas.setPointerCapture(e.pointerId); } catch (_) { /* synthetic */ }
    if (s.step === 'zutaten') zutatenDown(p);
    else if (s.step === 'giessen1') giessen1Down();
    else if (s.step === 'giessen2') giessen2Down();
    else if (s.step === 'klopfen') klopfenDown();
    else if (s.step === 'ausformen') ausformenDown(p, e);
    else if (s.step === 'fertig') s.rotDrag = p;
  }
  function onMove(e) {
    var p = canvasXY(e);
    var down = !!downPtrs[e.pointerId];
    if (s.step === 'zutaten') zutatenMove(p);
    else if (s.step === 'mischen') mischenMove(p, down);
    else if (s.step === 'einstreuen') einstreuenMove(p, down);
    else if (s.step === 'ruehren') ruehrenMove(p, down);
    else if (s.step === 'ausformen') ausformenMove(p, e);
    else if (s.step === 'fertig') fertigMove(p, down);
  }
  function onUp(e) {
    var p = canvasXY(e);
    var start = downPtrs[e.pointerId];
    delete downPtrs[e.pointerId];
    var wasTap = start && Math.hypot(p[0] - start[0], p[1] - start[1]) < 14;
    if (s.step === 'zutaten') zutatenUp(p, wasTap);
    else if (s.step === 'mischen') s.lastWipe = null;
    else if (s.step === 'einstreuen') { s.sprinkleOn = false; s.lastShovelX = null; }
    else if (s.step === 'ruehren') s.lastStir = null;
    else if (s.step === 'ausformen') ausformenUp(e);
    else if (s.step === 'fertig') s.rotDrag = null;
  }

  /* ================= loop + init ================= */

  function draw() {
    ctx.clearRect(0, 0, W, H);
    if (s.step === 'zutaten') zutatenDraw();
    else if (s.step === 'mischen') mischenDraw();
    else if (s.step === 'giessen1') giessen1Draw();
    else if (s.step === 'einstreuen') einstreuenDraw();
    else if (s.step === 'ruehren') ruehrenDraw();
    else if (s.step === 'giessen2') giessen2Draw();
    else if (s.step === 'klopfen') klopfenDraw();
    else if (s.step === 'warten') wartenDraw();
    else if (s.step === 'ausformen') ausformenDraw();
    else if (s.step === 'fertig') fertigDraw();
    stepParticles();
    drawParticles();
    // step indicator
    ctx.fillStyle = 'rgba(250,247,244,.45)'; ctx.textAlign = 'right';
    ctx.font = '600 14px "Ciutadella", system-ui, sans-serif';
    ctx.fillText('Schritt ' + (STEPS.indexOf(s.step) + 1) + '/10', W - 22, H - 20);
  }

  function tick() {
    requestAnimationFrame(tick);
    if (visible && s) draw();
  }

  function reset() {
    s = freshState();
    enter('zutaten');
  }

  function init() {
    canvas = document.getElementById('wk-canvas');
    if (!canvas) return;
    ctx = canvas.getContext('2d');
    taskEl = document.getElementById('wk-task');
    resetBtn = document.getElementById('wk-reset');
    canvas.addEventListener('pointerdown', onDown);
    canvas.addEventListener('pointermove', onMove);
    canvas.addEventListener('pointerup', onUp);
    canvas.addEventListener('pointercancel', onUp);
    if (resetBtn) resetBtn.addEventListener('click', reset);
    var io = new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.05 });
    io.observe(canvas);
    reset();
    requestAnimationFrame(tick);
  }

  // read-only introspection for tests/debugging
  window.KajuReiseWerkstatt = {
    probe: function () {
      if (!s) return null;
      return { step: s.step, water: s.water, pigment: s.pigment,
               mixDone: s.mixDone, fill: s.fill, slider: s.slider,
               bubblesLeft: s.bubbles.filter(function (b) { return !b.gone; }).length,
               stoneFree: s.stoneFree, earned: s.earned };
    },
    // deterministic step jump for QA (not wired to any UI)
    _goto: function (step) { if (STEPS.indexOf(step) >= 0) { s = freshState(); enter(step); if (step === 'giessen2' || step === 'klopfen' || step === 'warten' || step === 'ausformen') s.fill = 1; } }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
